/**
 * Created by andrey on 08.08.2025
 */

cc.Repeat = function (action, times) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._times = 0;
    this._total = 0;
    this._nextDt = 0;
    this._actionInstant = false;
    this._innerAction = null;

    if (times !== undefined) {
        this.initWithAction(action, times);
    }
};

cc.Repeat.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.Repeat,

    initWithAction: function (action, times) {
        const duration = action._duration * times;

        if (this.initWithDuration(duration)) {
            this._times = times;
            this._innerAction = action;
            if (action instanceof cc.ActionInstant) {
                this._actionInstant = true;
                this._times -= 1;
            }
            this._total = 0;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        this._total = 0;
        this._nextDt = this._innerAction._duration / this._duration;
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        this._innerAction.startWithTarget(target);
    },

    stop: function () {
        this._innerAction.stop();
        cc.Action.prototype.stop.call(this);
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);
        const locInnerAction = this._innerAction;
        const locDuration = this._duration;
        const locTimes = this._times;
        let locNextDt = this._nextDt;

        if (dt >= locNextDt) {
            while (dt > locNextDt && this._total < locTimes) {
                locInnerAction.update(1);
                this._total++;
                locInnerAction.stop();
                locInnerAction.startWithTarget(this.target);
                locNextDt += locInnerAction._duration / locDuration;
                this._nextDt = locNextDt;
            }

            // fix for issue #1288, incorrect end value of repeat
            if (dt >= 1.0 && this._total < locTimes) {
                this._total++;
            }

            // don't set a instant action back or update it, it has no use because it has no duration
            if (!this._actionInstant) {
                if (this._total === locTimes) {
                    locInnerAction.update(1);
                    locInnerAction.stop();
                } else {
                    // issue #390 prevent jerk, use right update
                    locInnerAction.update(dt - (locNextDt - locInnerAction._duration / locDuration));
                }
            }
        } else {
            locInnerAction.update((dt * locTimes) % 1.0);
        }
    },

    isDone: function () {
        return this._total === this._times;
    }
});

cc.repeat = (action, times) => new cc.Repeat(action, times);
